import { render, staticRenderFns } from "./participate.vue?vue&type=template&id=edd5c960&"
import script from "./participate.vue?vue&type=script&lang=js&"
export * from "./participate.vue?vue&type=script&lang=js&"
import style0 from "./participate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "participate.vue"
export default component.exports